import { useEffect, useRef } from 'react'

/**
 * Focus a heading when its screen appears, so the swap is announced. Without
 * it, pressing a control that unmounts itself leaves a screen-reader user,
 * on a desktop where `tel:` does nothing visible, hearing nothing at all.
 */
export function useFocusOnMount<T extends HTMLElement>(enabled = true) {
  const ref = useRef<T>(null)
  useEffect(() => {
    if (enabled) ref.current?.focus()
  }, [enabled])
  return ref
}
